import DefaultPageLayout from "@/layouts/DefaultPageLayout";
import DetailPageLayout from "@/layouts/DetailPageLayout";
import { Divider, Skeleton } from "@nextui-org/react";
import PageHeader from "../PageHeader";
function EmailBackupLoading() {
  return <DetailPageLayout disabledAnimation data-sentry-element="DetailPageLayout" data-sentry-component="EmailBackupLoading" data-sentry-source-file="index.tsx">
      <DefaultPageLayout className="min-h-[calc(100%)] !pb-[32px] flex flex-col gap-3 justify-between w-full" data-sentry-element="DefaultPageLayout" data-sentry-source-file="index.tsx">
        <div className="flex flex-col gap-5">
          <Skeleton className="h-6 w-24 mx-auto bg-default opacity-20 before:bg-default rounded" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
          <div className="flex flex-col gap-5 w-full">
            {/* Intro */}
            <div className="flex flex-col gap-3">
              <Skeleton className="h-5 w-24 bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
            </div>
            {/* Email Backup */}
            <div className="flex flex-col gap-3">
              <Skeleton className="h-5 w-28 bg-default opacity-20 before:bg-default rounded" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
              <Skeleton className="h-10 w-full bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
              <Skeleton className="h-4 w-8 ml-auto bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
            </div>
            {/* email verification code */}
            <div className="flex flex-col gap-3 w-full">
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-32 bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                <Skeleton className="h-4 w-16 bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
              </div>
              <Skeleton className="h-10 w-full bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-48 bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                <Skeleton className="h-4 w-8 ml-auto bg-default opacity-20 before:bg-default rounded " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
              </div>
            </div>
          </div>
        </div>
        <Skeleton className="h-[44px] w-full bg-default opacity-20 before:bg-default rounded-full " data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
      </DefaultPageLayout>
    </DetailPageLayout>;
}
export default EmailBackupLoading;